
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/kids-category/[category]",
      function () {
        return require("private-next-pages/kids-category/[category]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/kids-category/[category]"])
      });
    }
  